export const getBaseDomain = () => {
  let baseDomain = '';

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (window?.location?.port !== '') {
    const protocol = window.location.protocol + '//';
    const domain = location.host.replace(window?.location?.port, '80');
    baseDomain = protocol + domain;
  }

  return baseDomain;
}

export const replaceUrlPattern = (url: string, params: object) =>
  Object.keys(params).reduce((replacedUrl: string, paramKey: any) => {
    const regExp = new RegExp(`{${paramKey}}`, "g");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    replacedUrl = replacedUrl.replace(regExp, params[paramKey]);

    return replacedUrl;
  }, url);
